import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success, ROUTES, getNewToken } from '../../shared/constants'
import moment from 'moment'

export const useLeave = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [leave, setLeave] = useState(false)
  const [leaveThisWeek, setLeaveThisWeek] = useState(false)
  const [monthLeave, setMonthleave] = useState(false)
  const { addNewLeave, editNewLeave, deleteNewLeave, getNewLeaves } = useContext(FeatureContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  const [cancelToken, setCancelToken] = useState()
  const history = useHistory()

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])

  const getBelowEmployeeLeaves = (dto = {}) => {
    axios
      .get(API.GET_BELOW_EMPLOYEE_LEAVES(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        if (data) {
          getNewLeaves(data.USR)
          setLeaveThisWeek(data.leaveRequestThisWeek)
          setMonthleave(data.getMonthlyData[0].data)
          //console.log('leave request data', data.paginate)
          setPaginate(data.paginate)
        }
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const approveLeave = (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .post(API.APPROVE_LEAVE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }

        // setLeaves(data.USR)
        if (data.lev.leaveApproved === 'APPROVED') {
          toastMessage('Leave Approved...!', success)
        }
        if (data.lev.leaveApproved === 'REJECTED') {
          // toastMessage('Leave Approved...!', success)
          toastMessage('Leave Rejected...!', success)
        }

        return getBelowEmployeeLeaves()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const deleteLeave = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_LEAVE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Leave Deleted Successfully', success)
        // addNewLeave(data.data)+
        deleteNewLeave(dto.leaveId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyLeave = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_LEAVE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.leaveId.length} Leave Deleted Successfully`, success)

        dto.leaveId.map((item) => deleteNewLeave(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        data.data.map((item) => addNewLeave(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
        return getBelowEmployeeLeaves()
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getLeaveReport = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_LEAVE_REPORT(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setLeave(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getLeaveRequest = async (dto) => {
    setLoading(true)
    axios
      .get(API.GET_LEAVE_REQUEST(dto.leaveId), header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        } else setLeave(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const editLeaveRequest = async (dto, callFunc = () => {}) => {
    setLoading(true)
    axios
      .put(API.EDIT_LEAVE_REQUEST, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Leave Request Update Successfully', success)
        history.push(ROUTES.LEAVE_REQUESTS)
        getBelowEmployeeLeaves({ from: moment().startOf('month').toISOString(), to: new Date().toISOString() })
        callFunc()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        callFunc()
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getPdfCsvData = async (dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(API.GET_BELOW_EMPLOYEE_LEAVES(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    getBelowEmployeeLeaves,
    approveLeave,
    deleteLeave,
    deleteManyLeave,
    BulkUpload,
    leaveThisWeek,
    monthLeave,
    loading,
    paginate,
    leave,
    getLeaveReport,
    getLeaveRequest,
    editLeaveRequest,
    downloadLoading,
    pdfCsvData,
    getPdfCsvData,
  }
}
